import styles from '../css/embed.scss';

import addStylesheet from './helpers/addStylesheet';

addStylesheet(styles);
